import Class from './c-view';
import './c-view@';

export default Class;